import { render, staticRenderFns } from "./UniversalSelector.vue?vue&type=template&id=2c59f259&scoped=true&"
import script from "./UniversalSelector.vue?vue&type=script&lang=js&"
export * from "./UniversalSelector.vue?vue&type=script&lang=js&"
import style0 from "./UniversalSelector.vue?vue&type=style&index=0&id=2c59f259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c59f259",
  null
  
)

export default component.exports